import React, { Component } from 'react';
import { Container, Row } from 'reactstrap';
import './Scoin.css';

class Packages extends Component {

	generatePackages = (packages) => {
		return packages.map((item, index) => {
			return (
				<div className="bundle-details ticket vvip_block" key={index}>
					<div className="bundle-title vip">
						<div className="bundle-title-vertical-container">
							<div className="bundle-title-vertical">
								<h2 className="bundle-name vip">{item.title}</h2>
							</div>
						</div>
					</div>
					<div className="bundle-content">
						<p className="description">{item.description}</p>
						<a href={"package-detail/" + item.id} className="button-buy-vip">Chọn Gói Này</a>
					</div>
				</div>

			)
		})
	}
	render() {
		if (this.props.getPackagesAvailable.loading) return "Loading...";
		if (this.props.getPackagesAvailable.error) return `Error! ${this.props.getPackagesAvailable.error.message}`;
		let packages = this.props.getPackagesAvailable.getPackagesAvailable;
		return (
			<div className="bg-black">
				<div className="select-bundle-vip">
					<Container>
						<Row>
							<div className="col-xs-12 col-md-6 col-md-offset-3">
								<div className="boxes">
									<div className="box past">
										<div className="inner active">
											<div className="icon"><i className="fa fa-credit-card-alt fa-2x" aria-hidden="true"></i></div>
											<p>Chọn gói</p>
										</div>
									</div>
									<div className="box past">
										<div className="inner">
											<div className="icon"><i className="fa fa-credit-card fa-2x" aria-hidden="true"></i></div>
											<p>Thanh toán</p>
										</div>
									</div>
									<div className="box past">
										<div className="inner">
											<div className="icon"><i className="fa fa-check-square-o fa-2x" aria-hidden="true"></i></div>
											<p>Hoàn thành</p>
										</div>
									</div>
								</div>
							</div>
							<div className="col-xs-12">
								{this.generatePackages([...packages])}
							</div>
						</Row>
					</Container >
				</div>
			</div>
		);
	}
}

export default Packages;


// WEBPACK FOOTER //
// ./src/components/Scoin/Packages.js